import React from "react";
import { Layout } from "antd";
const { Footer } = Layout;

export default function Index() {
  return (
    <Footer
      style={{
        textAlign: "center",
      }}
    >
      xxx xxx xxx xxx
    </Footer>
  );
}
